function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconGefundenWerden = function SvgIconGefundenWerden(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 112.51 112.51",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a",
    transform: "translate(-903.89 -483.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M963.75,483.12h52.65a0,0,0,0,1,0,0v58.51a54,54,0,0,1-54,54h-5.86A52.65,52.65,0,0,1,903.89,543v0a59.86,59.86,0,0,1,59.86-59.86Z",
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#a)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.86,0h52.65a0,0,0,0,1,0,0V58.51a54,54,0,0,1-54,54H52.65A52.65,52.65,0,0,1,0,59.86v0A59.86,59.86,0,0,1,59.86,0Z",
    style: {
      fill: "#dfeafc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M941.91,538.06a27.15,27.15,0,1,1-27.15,27.15,27.16,27.16,0,0,1,27.15-27.15Z",
    transform: "translate(-903.89 -483.12)",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M942.38,544.85a6.92,6.92,0,1,1-6.91,6.92,6.92,6.92,0,0,1,6.91-6.92Z",
    transform: "translate(-903.89 -483.12)",
    style: {
      fill: "#fec543",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M993.17,508.08c3.82,0,6.92,2.74,6.92,6.11s-3.1,6.1-6.92,6.1-6.92-2.73-6.92-6.1,3.1-6.11,6.92-6.11Z",
    transform: "translate(-903.89 -483.12)",
    style: {
      fill: "#3e84fb",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "52.33 85.11 25.64 85.11 25.64 106.44 52.33 106.44 52.33 85.11 52.33 85.11",
    style: {
      fill: "#fec543",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "103.12 45.58 76.42 45.58 76.42 64.41 103.12 64.41 103.12 45.58 103.12 45.58",
    style: {
      fill: "#3e84fb",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M942.43,594.74a30.08,30.08,0,1,1,30.08-30.08,30.11,30.11,0,0,1-30.08,30.08Zm0-55.86a25.78,25.78,0,1,0,25.78,25.78,25.8,25.8,0,0,0-25.78-25.78Z",
    transform: "translate(-903.89 -483.12)",
    style: {
      fill: "#383838"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M994,521.7a8.6,8.6,0,1,1,8.59-8.6,8.6,8.6,0,0,1-8.59,8.6Zm0-12.89a4.3,4.3,0,1,0,4.3,4.29,4.3,4.3,0,0,0-4.3-4.29Z",
    transform: "translate(-903.89 -483.12)",
    style: {
      fill: "#383838"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1009,543.18a2.15,2.15,0,0,1-2.15-2.15v-4.3a6.45,6.45,0,0,0-6.44-6.44H987.55a6.45,6.45,0,0,0-6.45,6.44V541a2.15,2.15,0,1,1-4.3,0v-4.3A10.76,10.76,0,0,1,987.55,526h12.89a10.75,10.75,0,0,1,10.74,10.74V541a2.15,2.15,0,0,1-2.15,2.15Z",
    transform: "translate(-903.89 -483.12)",
    style: {
      fill: "#383838"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M979,533.4a2.15,2.15,0,0,1,2.15,2.15v4.29a6.45,6.45,0,0,0,6.45,6.45h12.89a6.45,6.45,0,0,0,6.44-6.45v-4.29a2.15,2.15,0,0,1,4.3,0v4.29a10.76,10.76,0,0,1-10.74,10.75H987.55a10.76,10.76,0,0,1-10.75-10.75v-4.29A2.15,2.15,0,0,1,979,533.4Z",
    transform: "translate(-903.89 -483.12)",
    style: {
      fill: "#383838"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M927.57,576.39a2.15,2.15,0,0,1,2.15,2.15v4.29a6.45,6.45,0,0,0,6.44,6.45h12.89a6.45,6.45,0,0,0,6.45-6.45v-4.29a2.15,2.15,0,1,1,4.29,0v4.29a10.75,10.75,0,0,1-10.74,10.75H936.16a10.76,10.76,0,0,1-10.74-10.75v-4.29a2.15,2.15,0,0,1,2.15-2.15Z",
    transform: "translate(-903.89 -483.12)",
    style: {
      fill: "#383838"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M942.43,560.36a8.59,8.59,0,1,1,8.59-8.59,8.6,8.6,0,0,1-8.59,8.59Zm0-12.89a4.3,4.3,0,1,0,4.3,4.3,4.3,4.3,0,0,0-4.3-4.3Z",
    transform: "translate(-903.89 -483.12)",
    style: {
      fill: "#383838"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M957.47,581.85a2.15,2.15,0,0,1-2.15-2.15v-4.3a6.45,6.45,0,0,0-6.44-6.44H936a6.45,6.45,0,0,0-6.45,6.44v4.3a2.15,2.15,0,1,1-4.29,0v-4.3A10.75,10.75,0,0,1,936,564.66h12.89a10.75,10.75,0,0,1,10.74,10.74v4.3a2.15,2.15,0,0,1-2.15,2.15Z",
    transform: "translate(-903.89 -483.12)",
    style: {
      fill: "#383838"
    }
  })));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconGefundenWerden, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Icon_Gefunden_Werden.6a93ae0a.svg";
export { ForwardRef as ReactComponent };